// extracted by mini-css-extract-plugin
module.exports = {"localVideo":"LocalVideo_localVideo__3mNGj","fileNameHolder":"LocalVideo_fileNameHolder__2vlkB","fileNameValueHolder":"LocalVideo_fileNameValueHolder__3QHL3"};